<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-headline-5" *ngIf="context === undefined">
      {{ "notFoundPage.errorText" | translate }}
    </mat-card-title>
    <mat-card-title class="mat-headline-5" *ngIf="context === NotFoundContext.verifyTokenExpired">
      {{ "notFoundPage.confirmationLinkExpired" | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <img src="app/shared/assets/images/404_error.svg" alt="Image of a 404 error" />
  </mat-card-content>
  <mat-card-actions>
    <button mat-raised-button color="primary" (click)="returnHome()">
      {{ "notFoundPage.returnHome" | translate }}
    </button>
  </mat-card-actions>
</mat-card>
